<template>
  <div>
    <b-row class="below">
      <b-col sm="2" lg="2">문제</b-col>
      <b-col v-html="title"></b-col>
    </b-row>
    <b-row class="below">
      <b-col sm="2" lg="2">분석</b-col>
      <b-col>
        <table class="table table-dark">
          <tr :key="item.id" v-for="item in ays_answers_str">
            <td v-html="item.text"></td>
            <td width="50px">{{ item.strt }}</td>
            <td>{{ item.intent_str }}</td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <b-row class="below">
      <b-col sm="2" lg="2">해석</b-col>
      <b-col>
        <table class="table table-dark">
          <tr :key="item.id" v-for="item in comt_answers_str">
            <td v-html="item.text"></td>
            <td>{{ item.strt }}</td>
            <td>(해당없음)</td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <b-row class="below">
      <b-col sm="2" lg="2">스크램블</b-col>
      <b-col>
        <table class="table table-dark">
          <tr :key="item.id" v-for="item in shuffle_answers_str">
            <td
              width="67%"
              style="word-break: break-all"
              v-html="item.text_str"
            ></td>

            <td width="33%">{{ item.intent_str }}</td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import * as R from "ramda";
const senStore = "senStore";
export default {
  computed: {
    ...mapState(senStore, ["ays_answers", "comt_answers", "shuffle_answers"]),
    ays_answers_str() {
      return R.map((f) => {
        f.intent_str = f.intent.d1 + "->" + f.intent.d2 + "->" + f.intent.d3;
        return f;
      }, this.ays_answers);
    },
    comt_answers_str() {
      return R.map((f) => {
        f.intent_str = f.intent.d1 + "->" + f.intent.d2 + "->" + f.intent.d3;
        return f;
      }, this.comt_answers);
    },
    shuffle_answers_str() {
      return R.map((f) => {
        f.intent_str = f.intent.d1 + "->" + f.intent.d2 + "->" + f.intent.d3;
        // f.text_str = f.text.split(" ").join("|");
        f.text_str = f.text;
        return f;
      }, this.shuffle_answers);
    },

    title() {
      return this.$store.state.questionform.title;
    },
    answers() {
      let qform = this.$store.state.questionform;
      let answers = [];
      if (this.q_type == "1") {
        for (let i = 1; i <= 5; i++) {
          if (qform[`ans${i}_text`] != "") {
            let a = {};
            a.id = i;
            a.t1 = qform[`ans${i}`];
            a.t2 = qform[`ans${i}_text`];
            answers.push(a);
          }
        }
      } else if (this.q_type == "2") {
        console.log(qform);

        for (let i = 0; i < this.$store.state.qtype2_picks.length; i++) {
          let a = {};
          a.id = i + 1;
          a.t1 = this.$store.state.qtype2_picks[i].text;
          a.t3 = this.$store.state.qtype2_picks[i].sub ? "[정답]" : "";
          answers.push(a);
        }
      } else if (this.q_type == "3") {
        console.log(this.$store.state.qtype3_picks);

        for (let i = 0; i < this.$store.state.qtype3_picks.length; i++) {
          let a = {};
          a.id = i + 1;
          a.t1 = this.$store.state.qtype3_picks[i].text;
          a.t2 = this.$store.state.qtype3_picks[i].answer;

          a.t3 = this.$store.state.qtype3_picks[i].sub ? "[정답]" : "";
          answers.push(a);
        }
      } else if (this.q_type == "4") {
        let a = {};
        a.id = 1;
        a.t1 = qform.ans1;
        answers.push(a);
      }

      return answers;
    },
  },
};
</script>


<style lang="scss">
@import "@/styles/_variables.scss";
.below {
  padding-bottom: 6px;
  padding-top: 6px;
  border-bottom: 1px solid $gray100;

  img {
    max-width: 450px;
  }
}
</style>